import {
  ThemeTemplateItem,
  ThemeTemplateModel,
  ThemeType,
} from "states/theme-template/theme-template.models";

export const setValueFromTemplate = (template: ThemeTemplateItem) => {
  let valueModel: any = {};
  if (
    template.type === ThemeType.GroupList ||
    template.type === ThemeType.ImageList
  ) {
    valueModel = [];
  }
  if (template.type === ThemeType.Group) {
    for (let propName in template.value) {
      valueModel[propName] = setValueFromTemplate(
        template.value[propName] as ThemeTemplateItem
      );
    }
  }
  return valueModel;
};

export const convertToThemeTemplateItem = (
  templateModel: ThemeTemplateModel
): ThemeTemplateItem => {
  return {
    name: templateModel.name,
    type: ThemeType.Group,
    value: templateModel.value,
  };
};
